
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/life",
      function () {
        return require("private-next-pages/life.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/life"])
      });
    }
  